import { API } from '@/utils'

export default {
    state: {
        allRegions: [],
        allDistrictsInRegion: []
    },
    mutations: {
        LOAD_DISTRICS_IN_REGION(state, payload) {
            state.allDistrictsInRegion = payload
        },
        LOAD_REGIONS(state, payload) {
            state.allRegions = payload
        },
        CLEAR_DISTRICS_STATE(state) {
            state.allDistrictsInRegion = []
        }
    },
    actions: {
        LOAD_DISTRICS_IN_REGION({ commit }, payload) {
            API.get(`/regions/${payload}/districts`)
            .then( response => {
                commit('LOAD_DISTRICS_IN_REGION', response.data)
            })
            .catch( error => {
                console.log(error)
            })
        },
        LOAD_REGIONS({ commit }) {
            API.get('/regions')
            .then( response => {
                commit('LOAD_REGIONS', response.data)
            })
            .catch( error => {
                console.log(error)
            })
        },
        CLEAR_DISTRICS_STATE({commit}){
            commit('CLEAR_DISTRICS_STATE')
        }
    },
    getters: {
        GET_ALL_REGIONS(state) {
            return state.allRegions
        },
        GET_ALL_DISTRICTS_IN_REGION(state) {
            return state.allDistrictsInRegion
        },
        GET_REGION_ID(state) {
            return name => {
                const region = state.allRegions.find(region => region.name == name)
                return region.id
            }
        }
    }
};